import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import {useEffect, useRef} from "react";
import * as portalShared from "../../portal/shared/metadataConstantsAndUtilities";

export default function ArgoMultipleSelectCheckmarksHook(props) {
    const [tagList, setTagList] = React.useState([]);

    const [built, setBuilt] = React.useState(false)

    const prevMenuItems = useRef()

    const fileName = props.fileName ?? "NoFileName";
    const fieldName = props.fieldName ?? "NoFieldName";

    const uniqueIdentifier = fileName + "-ArgoMultipleSelectCheckmarksHook-" + fieldName;

    const label = props.label ?? "";

    const menuItems = Array.isArray(props.menuItems)
        ? props.menuItems.filter(item => item !== undefined && item !== null)
        : [];

    const valueProperty = props.valueProperty ?? "value";

    const textProperty = props.textProperty ?? "text";

    const onChange = props.onChange ?? function () {};

    const selectedTags = props.selectedTags ?? []

    const width = props.width ?? 150;

    const minWidth = props.minWidth ?? 150;

    const dropDownWidth = props.dropDownWidth ?? 320

    const dropDownHeight = props.dropDownHeight ?? 200

    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: dropDownHeight,
                width: dropDownWidth,
            },
        },
    };

    useEffect(() => {
        const prevMenu = prevMenuItems.current

        if (!built && menuItems.length > 0) {
            buildTagList();
            setBuilt(true)
        }
        else if (prevMenu !== menuItems) buildTagList()

        prevMenuItems.current = menuItems
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(menuItems)]);

    useEffect(() => {
        if (built && selectedTags.length === 0) {
            buildTagList()
        }
        else if (selectedTags.length > 0 && !selectedTags.at(-1).hasOwnProperty("createdDate")){
            buildTagList()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[selectedTags]);

    const sortTag = (sortList) => {
        let checked = sortList.filter(tag => tag.checked)
        let unchecked = sortList.filter(tag => !tag.checked)
        checked = checked.sort((a, b) => a.name.localeCompare(b.name))
        unchecked = unchecked.sort((a, b) => a.name.localeCompare(b.name))
        return [...checked, ...unchecked]
    }

    const handleOnClose = (event) => {
        let tempTagList = []
        let clonedTagList = [...tagList]

        for (let i= 0; i < clonedTagList.length; i++) {
            let tempRow = portalShared.cloneObj(clonedTagList[i]);
            tempRow.checked = (selectedTags.some(tag => tag.id === tempRow.id));
            tempTagList.push(tempRow);
        }

        setTagList(sortTag(tempTagList))
    }

    const buildTagList = () => {
        let tempTagList = [];
        let clonedMenuItems = [...menuItems];

        for (let i= 0; i < clonedMenuItems.length; i++) {
            let tempRow = portalShared.cloneObj(clonedMenuItems[i]);
            tempRow.checked = (selectedTags.some(tag => tag.id === tempRow.id));
            tempTagList.push(tempRow);
        }

        const newTags = selectedTags.filter(tag => !tag.hasOwnProperty("createdDate"))
        if (newTags.length > 0) {
            tempTagList = [...tempTagList, ...newTags]
        }

        setTagList(sortTag(tempTagList));
    };


    const handleChange = (event) => {
        const selectedTagsArr = event.target.value

        const updateTagList = tagList.map(tag => ({...tag, checked: selectedTagsArr.includes(tag.name)}))

        setTagList(updateTagList)
        onChange(event, fieldName, updateTagList);
    };

    return (
            <FormControl variant="standard" sx={{width: width, minWidth: minWidth}}>
                <InputLabel id={uniqueIdentifier}>{label}</InputLabel>
                <Select
                    labelId={uniqueIdentifier}
                    id={uniqueIdentifier + "checkbox"}
                    multiple
                    value={tagList.filter(tag => tag.checked).map(tag => tag.name)}
                    onChange={handleChange}
                    onClose={handleOnClose}
                    renderValue={(selected) => selected.join(', ')}
                    MenuProps={MenuProps}
                >
                    {tagList.map((row) => {
                        if (!row || row[valueProperty] === undefined || row[textProperty] === undefined) {
                            return null;
                        }

                        const textValue = row[textProperty];
                        return (
                            <MenuItem key={row[valueProperty]} value={textValue} sx={{ height: 35 , padding: '5px'}}>
                                <Checkbox checked={row.checked} />
                                <ListItemText primary={textValue.toString()}/>
                            </MenuItem>
                        );
                    })}
                </Select>
            </FormControl>

    );
}
